<template>
<div>
    <div class="content">
        <!-- BEGIN FORGOT PASSWORD FORM -->
        <form aria-label="Reset Password" class="forget-form">
            <input type="hidden" name="token" v-model="form.token">
            <div class="logo">
                <a href="/public">
                    <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart"
                         style="margin-top: -5px; margin-right: 5px; max-height:107px; max-width:300px;">
                    <span v-else>{{ project }}</span>
                </a>
            </div>
            <h3 class="font-green">Reset Password</h3>
            <div class="alert alert-danger" :class="[ errors.email.length ? 'display-show' : 'display-hide' ]">
                <button class="close" type="button" @click="clearErrors('email')"></button>
                <div v-for="(error, i) in errors.email" :key="i">{{ error }}</div>
            </div>
            <div class="alert alert-danger" :class="[ errors.password.length ? 'display-show' : 'display-hide' ]">
                <button class="close" type="button" @click="clearErrors('password')"></button>
                <div v-for="(error, i) in errors.password" :key="i">{{ error }}</div>
            </div>
            <div class="form-group">
                <label class="control-label visible-ie8 visible-ie9">Email</label>
                <input class="form-control" :class="{'is-invalid': errors.email.length}" v-model="form.email"
                       type="email" placeholder="Email" name="email" @input="clearErrors('email')"
                       id="email" required disabled>
            </div>
            <div class="form-group">
                <label class="control-label visible-ie8 visible-ie9">Password</label>
                <input class="form-control" :class="{'is-invalid': errors.password.length}" v-model="form.password"
                       type="password" placeholder="Password" name="password" @input="clearErrors('password')"
                       id="password" required>
            </div>
            <div class="form-group">
                <label class="control-label visible-ie8 visible-ie9">Confirm Password</label>
                <input class="form-control" v-model="form.password_confirmation"
                       type="password" placeholder="Confirm Password" name="password_confirmation"
                       id="password-confirm" required>
            </div>
            <div class="form-actions">
                <button @click.prevent="sendForm" type="button" class="btn green uppercase">Reset Password</button>
            </div>
        </form>
        <!-- END FORGOT PASSWORD FORM -->
    </div>
    <div class="copyright">© {{ new Date().getFullYear() }} {{ project }} {{ appType }}</div>
</div>
</template>

<script>
import r from "@/js/route";
import httpClient from '@/js/services/http-client';

export default {
    name: "Reset",

    data: () => ({
        pending: false,
        form: {
            token: '',
            email: '',
            password: '',
            password_confirmation: '',
        },

        errors: {
            email: [],
            password: [],
        },

        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
    }),

    created () {
        this.form.token = this.$route.params.token
        this.form.email = this.$route.query.email
    },

    methods: {
        sendForm() {
            if (this.pending === false) {
                this.pending = true;
                httpClient.post(r('password.reset'), this.form)
                    .then(({ data }) => {
                        window.location.href = '/dashboard';
                    })
                    .catch(err => {
                        console.log(err.response.data.errors);

                        this.handleErrors(err.response.data.errors);
                    })
                    .then(() => {
                        this.pending = false;
                    });
            }
        },

        handleErrors(errors) {
            if (errors) {
                this.setErrors(errors)
            } else {
                this.clearErrors()
            }
        },

        setErrors(errors) {
            for (let key in this.errors) {
                if (Object.hasOwnProperty.call(this.errors, key)) {
                    this.errors[key] = errors[key] || []
                }
            }
        },

        clearErrors(key = false) {
            console.log(this.errors)
            if (key) {
                if (this.errors[key].length) {
                    this.errors[key] = []
                }
            } else {
                for (let key in this.errors) {
                    if (Object.hasOwnProperty.call(this.errors, key)) {
                        this.errors[key] = []
                    }
                }
            }
        }
    }
}
</script>

<style scope="scoped">

</style>
